module.exports = __webpack_public_path__ + "img/airarabia.a3a7dc1b.png";